import type React from 'react';
import { useSelector } from 'react-redux';

import HdpContentWrapper from 'app/shared/modules/hdp/HdpContentWrapper';
import { listingUtils_shouldShowPpcLink } from 'app/shared/utils/listingUtils';
import PpcLink from 'app/shared/modules/hdp/PpcLink';
import Container from 'app/shared/core/Container';
import { hdpPpcLinkContainer } from './hdpPpcLink.styles';
import type { RootReduxState } from 'app/shared/flux/reducers';
import type { ListingDetails } from 'app/types/listingDetails.type';

interface HdpPpcLinkProps {
  listing: ListingDetails;
  ppcLocation: 'address' | 'hdp' | 'summary';
}

const HdpPpcLink: React.FC<HdpPpcLinkProps> = (props) => {
  const device = useSelector((state: RootReduxState) => state.app.device);
  const { listing, ppcLocation } = props;

  if (!listingUtils_shouldShowPpcLink(listing.details, device)) {
    return null;
  }

  return (
    <HdpContentWrapper active fullContent>
      <Container className={hdpPpcLinkContainer}>
        <PpcLink listing={listing} ppcLocation={ppcLocation} />
      </Container>
    </HdpContentWrapper>
  );
};

export { HdpPpcLink };
export default HdpPpcLink;
